import { render } from "./WorkspaceDeletePage.vue?vue&type=template&id=44cae609"
import script from "./WorkspaceDeletePage.vue?vue&type=script&lang=js"
export * from "./WorkspaceDeletePage.vue?vue&type=script&lang=js"

import exportComponent from "/usr/app/saas-stack/admin-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__